import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { HandleHttpError } from '../core/utils/HttpHandleError';
import { FiltroBlog } from '../shared/models/filtro-blog';

@Injectable({
  providedIn: 'root'
})
export class GestorContenidoService {
  url: string = `${environment.apiLocalUrl}cms`;
  constructor(private http: HttpClient) {}

  //Servicios para los articulos
  getArticulos(pagina : number){
    return this.http.get(`${this.url}/articulos/buscarTodos/${pagina}`).pipe(catchError(HandleHttpError));
  }

  getArticulosPrincipales(pagina : number){
    return this.http.get(`${this.url}/articulos/buscarPrincipales/${pagina}`).pipe(catchError(HandleHttpError));
  }

  getArticuloPorId(idArticulo : number){
    return this.http.get(`${this.url}/articulos/buscarPorId/${idArticulo}`).pipe(catchError(HandleHttpError));
  }
  
  getArticulosPorFiltros(body : FiltroBlog){
    return this.http.post(`${this.url}/articulos/buscarPorFiltros`, body).pipe(catchError(HandleHttpError));
  }

  //servicios para noticias
  getNoticias(pagina : number){
    return this.http.get(`${this.url}/noticias/buscarTodos/${pagina}`).pipe(catchError(HandleHttpError));
  }

  getNoticiasPrincipales(pagina : number){
    return this.http.get(`${this.url}/noticias/buscarPrincipales/${pagina}`).pipe(catchError(HandleHttpError));
  }

  getNoticiaPorId(idNoticia : number){
    return this.http.get(`${this.url}/noticias/buscarPorId/${idNoticia}`).pipe(catchError(HandleHttpError));
  }

  getNoticiasPorFiltros(body : FiltroBlog){
    return this.http.post(`${this.url}/noticias/buscarPorFiltros`, body).pipe(catchError(HandleHttpError));
  }

  //Servicios productos
  getProductos(pagina : number){
    return this.http.get(`${this.url}/productos/buscarTodos/${pagina}`).pipe(catchError(HandleHttpError));
  }
  getProductosPrincipales(pagina : number){
    return this.http.get(`${this.url}/productos/buscarPrincipales/${pagina}`).pipe(catchError(HandleHttpError));
  }
  getProductosPorId(idProducto : number){
    return this.http.get(`${this.url}/productos/buscarPorId/${idProducto}`).pipe(catchError(HandleHttpError));
  }
  getProductosPorFiltros(body : FiltroBlog){
    return this.http.post(`${this.url}/productos/buscarPorFiltros`,body).pipe(catchError(HandleHttpError));
  }

  //Servicios Videos
  getVideos(pagina : number){
    return this.http.get(`${this.url}/videos/buscarTodos/${pagina}`).pipe(catchError(HandleHttpError));
  }
  getVideosPrincipales(pagina : number){
    return this.http.get(`${this.url}/videos/buscarPrincipales/${pagina}`).pipe(catchError(HandleHttpError));
  }
  getVideosPorId(idVideo : number){
    return this.http.get(`${this.url}/videos/buscarPorId/${idVideo}`).pipe(catchError(HandleHttpError));
  }
  getVideosPorFiltros(body : FiltroBlog){
    return this.http.post(`${this.url}/videos/buscarPorFiltros`,body).pipe(catchError(HandleHttpError));
  }

  //Servicios filtros 
  getEtiquetas(){
    return this.http.get(`${this.url}/etiquetas`).pipe(catchError(HandleHttpError));
  }
  getCategorias(){
    return this.http.get(`${this.url}/categorias`).pipe(catchError(HandleHttpError));
  }
  getAutores(){
    return this.http.get(`${this.url}/autores`).pipe(catchError(HandleHttpError));
  }
  getAutorPorUsername(username : string){
    return this.http.get(`${this.url}/autores/buscarPorUsername/${username}`).pipe(catchError(HandleHttpError));
  }

  //Logos footer
  getLogosFooter(pagina : number){
    return this.http.get(`${this.url}/logosFooter/buscarTodos/${pagina}`).pipe(catchError(HandleHttpError));
  }

  getLogosFooterPrincipales(pagina : number){
    return this.http.get(`${this.url}/logosFooter/buscarPrincipales/${pagina}`).pipe(catchError(HandleHttpError));
  }
  
  getLogosFooterPorId(idLogo : number){
    return this.http.get(`${this.url}/logosFooter/buscarPorId/${idLogo}`).pipe(catchError(HandleHttpError));
  }

  //Sección ¿que es neocrédito?
  getQueEsNeo(){
    return this.http.get(`${this.url}/queEsNeo/buscarPrincipal`).pipe(catchError(HandleHttpError));
  }
}
